import type { FlightTracePoint } from './types';

/** True when a tar1090 trace sample is on the ground. */
export function isTraceOnGround(p: FlightTracePoint): boolean {
  return p.altBaro === 0;
}

/**
 * Keep only the current flight leg: samples after the most recent takeoff.
 * Returns an empty array once the aircraft has landed so past trips are hidden.
 */
export function trimTraceToCurrentFlight(points: FlightTracePoint[]): FlightTracePoint[] {
  if (points.length === 0) return [];

  let start = 0;
  for (let i = 0; i < points.length - 1; i++) {
    if (isTraceOnGround(points[i]) && !isTraceOnGround(points[i + 1])) {
      start = i + 1;
    }
  }

  const leg = points.slice(start);
  if (leg.length === 0) return leg;
  if (isTraceOnGround(leg[leg.length - 1])) return [];
  if (leg.every(isTraceOnGround)) return [];

  return leg;
}
